import { render, staticRenderFns } from "./FormLabel.vue?vue&type=template&id=648564bb&scoped=true&"
import script from "./FormLabel.vue?vue&type=script&lang=ts&"
export * from "./FormLabel.vue?vue&type=script&lang=ts&"
import style0 from "./FormLabel.vue?vue&type=style&index=0&id=648564bb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648564bb",
  null
  
)

export default component.exports